// extracted by mini-css-extract-plugin
export default {"modalBodyTexts":"gNZiluMuwwFZUer9aXoz","primaryText":"N8eAsjmhAACsYj_q10gJ","secondaryText":"uUEX2MJrEHA5Anv0PvOb"};